import * as React from "react";
import {Fragment} from "react";
import SFXLoadingComponent from "../../SFXLoadingComponent";
import Card from "reactstrap/es/Card";
import SFXButtonComponent from "../../SFXButtonComponent";
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
import Modal from "reactstrap/es/Modal";
import ModalHeader from "reactstrap/es/ModalHeader";
import ModalBody from "reactstrap/es/ModalBody";
import ModalFooter from "reactstrap/es/ModalFooter";
import BopCategoryService from "../../../services/Transaction/inbound/BopCategoryService";
import ReportingDeclarationService
    from "../../../services/Transaction/reporting.declaration/ReportingDeclarationService";

export default class RedemptionDeclarationComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            idType: this.props.idType,
            beneficiaryAmount: this.props.beneficiaryAmount,
            accept: false,
            redemptionResponse: {},
            loading: true,
            showQuotationErrorModal: false,
            errorMessage: {},

            inValidFields: {},
            validFields: {},
            bopCategory: {}
        };
        this.props.setHeader()
    }

    componentDidMount() {
        BopCategoryService.get(this.state.idType, this.state.beneficiaryAmount, (this.props.lookupResponse.senderType === 'SELF')).then(response => {

        })
        let promises = []
        promises.push(BopCategoryService.get(this.state.idType, this.state.beneficiaryAmount, (this.props.lookupResponse.senderType === 'SELF')))
        promises.push(ReportingDeclarationService.getLatestVersion(false))

        Promise.all(promises).then(responses => {
            if (!responses[0].name) {
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    errorMessage: responses[0].message
                })
                return;
            }
            if(!responses[1].id){
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    errorMessage: responses[1].message
                })
                return;
            }
            this.setState({
                bopCategory: responses[0],
                reportingDeclaration: responses[1],
                loading: false
            })
        })
    }

    handleChange = (event, field) => {
        this.setState({
            pin: event.target.value
        });
    };

    toggleAccept() {
        this.setState({
            accept: !this.state.accept
        })
    }

    accepted() {
        return this.state.accept
    }

    submit() {
        this.props.submit(this.state.reportingDeclaration.version)
    }

    render() {

        if (this.state.loading)
            return <SFXLoadingComponent/>;

        return <Fragment>

            {this.props.className === 'mobile' ? this.renderContent('mobile') : this.renderBrowserContent('browser')}

        </Fragment>

    }

    renderContent(className) {

        return <Fragment>

            {this.renderErrorModal(className)}

            <div className={className + "_declaration_screen"}>
                <div>
                    <h6>I hereby declare the following:</h6>
                    <ul>
                        <li>I have read this document, know and understand the contents thereof.</li>
                        <li>The information furnished throughout this transaction is in all respects both true and
                            correct.
                        </li>
                        <li>The currency applied for will only be used for the specific purpose stated herein.</li>
                        <li>The documentation presented in support of this transaction is in all respects authentic.
                        </li>
                        <li>I have been informed of the limit applicable to this transaction and confirm that this limit
                            will not be exceeded because of the conclusion of this transaction.
                        </li>
                        <li>I consent to this information being provided to the South African Reserve Bank and/or the
                            Financial Intelligence Centre.
                        </li>
                        <li>I authorise Ria Money Transfer to sign my declaration on my behalf for any subsequent
                            transactions as set out in Section C.1 (E)(ii)(e) of the Currency and Exchanges Manual for
                            Authorised Dealers in foreign exchange with limited authority (ADLA Manual.)
                        </li>
                        <li>This declaration shall be binding and I agree that the terms of this declaration shall
                            remain in force and effect unless a notice of termination is received in writing duly signed
                            by me.
                        </li>
                    </ul>
                </div>
                <div>
                    <h6>Your transaction will be categorised according to the purpose and/or identification
                        documentation provided on registration for Inbound and Outbound transactions:</h6>
                    <ul>
                        <li>401 Gift - South African ID</li>
                        <li>416 Migrant workers remittance – Asylum documents</li>
                        <li>417 Foreign national contract worker remittance – Foreign passport</li>
                    </ul>
                </div>
                <div>
                    <h6>Once you apply for a higher limit your categories will change to the following:</h6>
                    <ul>
                        <li>305 Compensation paid by a resident to a migrant worker/employee – Asylum document</li>
                        <li>306 Compensation paid by a resident to a foreign national contract worker employee – Foreign
                            Passport
                        </li>
                    </ul>
                </div>
                <div>
                    <h6>Self to Self-Inbound:</h6>
                    <ul>
                        <li>303 Compensation/salaries paid by a non-resident to a resident employee temporarily abroad
                        </li>
                    </ul>
                </div>
                {/*<div>*/}
                {/*    <b>Your transaction will be categorised as: </b>*/}
                {/*    <div>*/}
                {/*        <ul>*/}
                {/*            <li>*/}
                {/*                {this.state.bopCategory.reportingCode}*/}
                {/*                &nbsp;-&nbsp;*/}
                {/*                {this.state.bopCategory.inboundDescription}*/}
                {/*            </li>*/}
                {/*        </ul>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {this.renderTickBox()}
                {this.renderSubmitButton(className)}
            </div>
        </Fragment>
    }

    renderBrowserContent(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto",
            marginBottom: "100px"
        }}>
            {this.renderContent(className)}
        </Card>
    }

    renderSubmitButton(className) {
        return <Fragment>
            {className === "browser" ? <br/> : <Fragment></Fragment>}
            <div className={className + "_register_button_div"}>
                <SFXButtonComponent
                    className={className + "_orange_oval_button"}
                    onClick={() => this.submit()}
                    disabled={!this.state.accept || !this.props.documentUploadComplete}
                >Submit</SFXButtonComponent>
            </div>
        </Fragment>
    }

    renderTickBox(className) {

        return <Fragment>
            <Row className={className + "_row"}>
                <Col>

                    <input style={{scale: "1.5"}}
                           onChange={() => this.toggleAccept()}
                           type="checkbox"
                           checked={this.state.accept}
                    />
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;I accept and acknowledge the declaration</span>
                </Col>
            </Row>

        </Fragment>
    }

    renderErrorMessage(className, field, message) {
        return <h6 className={className + "_error_text"}>
            {message}
        </h6>;
    }

    renderErrorModal(className) {
        return <Modal isOpen={this.state.showErrorModal} className={'modal-danger modal-md'}>
            <ModalHeader className={className + "_modal_header modal-header"}>Invalid Input</ModalHeader>
            <ModalBody>
                {this.state.errorMessage}
            </ModalBody>
            <ModalFooter>
                <SFXButtonComponent onClick={this.props.onModalCancelClick}>
                    Close
                </SFXButtonComponent>
            </ModalFooter>
        </Modal>
    }
}
